/**
 * Social sharing buttons script
 */
 class FinHub_SocialSharing {
  constructor() {
    if(!$('.post-sharing').length) {
      return;
    }
    this.initPopups();
  }
  initPopups() {
    $('.post-sharing-link').each(function(i, link) {
      $(link).on('click', function(e) {
        e.preventDefault();
        window.open($(link).attr('href'), 'Share this post', 'width=500,height=400,resizable=yes').focus();
      });
    });
  }
}
